import script from "./edit-room-measurements.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit-room-measurements.vue?vue&type=script&lang=ts&setup=true"

import "./edit-room-measurements.vue?vue&type=style&index=0&id=75dbb359&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75dbb359"]])

export default __exports__